export default "__VITE_ASSET__AdFzoO30pW$n9GHudK3dCg__"